import jsCookie from 'js-cookie';
import { isLocal, isInternational } from '../../util/env';

/**
 * http 请求服务策略
 *
 * @export
 * @class CookieService
 */
class CookieService {

    constructor() {
        this.synonymMaps = {
            // web 社区使用的是 utoken，mblock5编辑器内部使用的是 Token
            'Token': 'utoken'
        };
    }

    get config() {
        let domain = isInternational() ? 'mblock.cc' : 'makeblock.com';
        let config = isLocal() ? {} : {
            domain,
            'expires': 365 // 设置过期时间为一年
        };
        return config;
    }

    /**
     * 设置本地存储内容
     *
     * @param {any} key
     * @param {any} value
     * @returns
     *
     * @memberOf CookieService
     */
    set(key, value) {
        this.remove(key);
        jsCookie.set(key, value, this.config);
        if (this.synonymMaps[key]) {
            jsCookie.set(this.synonymMaps[key], value, this.config);
        }
        return true;
    }

    /**
     * 获取本地存储里的内容
     *
     * @param {any} key
     * @returns
     *
     * @memberOf CookieService
     */
    get(key) {
        let result = jsCookie.get(key) || this.synonymMaps[key] && jsCookie.get(this.synonymMaps[key]);
        try {
            return JSON.parse(result);
        } catch (err) {
            return result;
        }
    }

    /**
     * 移除本地存储里的内容
     *
     * @param {any} key
     * @returns
     *
     * @memberOf CookieService
     */
    remove(key) {
        jsCookie.remove(key, this.config);
        if (this.synonymMaps[key]) {
            jsCookie.remove(this.synonymMaps[key], this.config);
        }
        return true;
    }

    clear() {
        console.warn('no clear function');
    }
}

export default new CookieService();